import { MessageKey } from './messages-fr';

export const messagesEn: Record<MessageKey, string> = {
  'topbar.app_name': 'Ramp quote',
  'topbar.tagline': 'For All · Pour Tous',
  'topbar.lang_fr': 'FR',
  'topbar.lang_en': 'EN',
  'hero.status': 'Internal tool · CCQ rules built in',
  'hero.title': 'Configure your ramp',
  'hero.meta': 'All on one page · PDF + Excel + native email',
  'section.01.title': 'Base measurements',
  'section.02.title': 'Ramp shape',
  'section.03.title': 'Options',
  'section.04.title': 'Summary + 3D',
  'section.05.title': 'Client and send',
  'measures.usage.label': 'Usage',
  'measures.usage.res': 'Residential',
  'measures.usage.com': 'Commercial',
  'measures.height.label': 'Height to climb (in)',
  'measures.floor.label': 'Floor type',
  'measures.floor.plein': 'Solid',
  'measures.floor.mailles': 'Mesh',
  'measures.floor.com_locked': 'Commercial requires SOLID floor (safety).',
  'measures.slope.ok': 'Slope {percent}% — compliant GR + CCQ',
  'measures.slope.warn': 'Slope {percent}% — watch closely',
  'measures.slope.error': 'Slope too steep ({percent}%) — extend the run',
  'shape.form.label': 'Shape',
  'shape.form.straight': 'Straight',
  'shape.form.l90': 'L-shape (90°)',
  'shape.form.u180': 'U-shape (180°)',
  'shape.run.label': 'Total run (in)',
  'shape.arm1.label': 'Arm 1 (in)',
  'shape.arm2.label': 'Arm 2 (in)',
  'shape.landing.label': 'Landing (in)',
  'shape.width.label': 'Width (in)',
  'shape.rail.label': 'Handrail',
  'shape.rail.aucun': 'None',
  'shape.rail.ajoure': 'Openwork',
  'shape.rail.barrotin': 'Picket',
  'shape.rail.barrotin_mains': 'Picket with handrail',
  'shape.rail.warn_height': 'Height > 24" — guardrail required (CCQ fall > 600 mm)',
  'shape.rail.accept': 'Accept {type}',
  'options.mode.label': 'Mode',
  'options.mode.achat': 'Purchase',
  'options.mode.location': 'Rental',
  'options.rental.duration': 'Rental duration (months)',
  'options.install.label': 'Installation + transport',
  'options.install.km': 'Distance one-way (km)',
  'options.uninstall.label': 'Uninstall (round-trip transport)',
  'recap.preview3d': '3D preview · drag to rotate',
  'recap.subtotal': 'Subtotal',
  'recap.tps': 'GST (5%)',
  'recap.tvq': 'QST (9.975%)',
  'recap.grand_total': 'GRAND TOTAL',
  'recap.rental.monthly': 'Monthly ({months} months)',
  'recap.rental.total': 'Total rental',
  'recap.rental.buyback': 'Buyback 20%',
  'recap.alerts.title': 'Watch out',
  'recap.errors.title': 'Fix required',
  'recap.info.title': 'For your reference',
  'client.subtitle': '{usage} · {height} in tall',
  'client.usage.res': 'Residential',
  'client.usage.com': 'Commercial',
  'client.name.label': 'Client name',
  'client.name.placeholder': 'e.g.: Marie Tremblay',
  'client.address.label': 'Site address',
  'client.address.placeholder': 'e.g.: 456 Pine Ave, Montreal',
  'client.email.label': 'Client email (for sending)',
  'client.email.placeholder': 'e.g.: marie.tremblay@email.ca',
  'client.photo.label': 'Site photo (optional)',
  'client.photo.placeholder': 'Take / choose a photo',
  'client.photo.added': 'Photo added',
  'cta.send_email': 'Send by email',
  'cta.send_email.busy': 'Preparing…',
  'cta.download_pdf': 'Download PDF',
  'cta.download_pdf.busy': 'Generating…',
  'cta.download_excel': 'Download Excel',
  'cta.download_excel.busy': 'Generating…',
  'toast.pdf_done': 'PDF downloaded',
  'toast.excel_done': 'Excel downloaded',
  'toast.email_shared': 'Quote shared',
  'toast.email_mailto': 'Email opened (no attachments)',
  'toast.email_cancelled': 'Share cancelled',
  'toast.no_quote': 'No quote to export',
  'toast.error_pdf': 'PDF generation error',
  'toast.error_excel': 'Excel generation error',
  'toast.error_email': 'Share error',
  'footer.copyright': 'Confidential · ©2026',
  'app.loading_catalog': 'Loading catalog…',
  'app.catalog_error.title': 'Loading error',
  'app.catalog_error.body': 'Unable to load product catalog.',
  'app.catalog_error.reload': 'Reload',
  'email.body.greeting': 'Hello {name},',
  'email.body.intro': 'Please find your quote attached.',
  'email.body.signoff': 'Best regards,',
  'shape.l90.turn.label': 'Turn direction',
  'shape.l90.turn.left': 'Left',
  'shape.l90.turn.right': 'Right',
  'shape.l90.landing.label': 'Turn landing',
  'shape.l90.landing.5x5': '5×5 (60×60") — standard',
  'shape.l90.landing.5x8': '5×8 (60×96") — tall',
  'shape.head_platform.label': 'Head platform',
  'shape.head_platform.5x5': '5×5 (60×60") — standard',
  'shape.head_platform.5x8': '5×8 (60×96") — tall',
  'chart.title': 'Official inclination chart',
  'chart.subtitle': 'Go Rampe reference · height × length → angle',
  'chart.close': 'Close',
  'chart.legend': 'Legend:',
  'chart.current': 'Your config: {height}″ × {length}′ → {angle}°',
  'chart.height_label': 'Height (in) ↓',
  'chart.footer': 'Source: Go Rampe Inc. · 1-888-957-2673 · contact@gorampe.com',
  'measures.slope.view_chart': 'View chart',
  'bom.qty': 'Quantity',
  'bom.cut_from_stock': 'cut from stock',
  'bom.material': 'Material',
  'bom.tree.aria': 'BOM list',
  'bom.title': 'Bill of Materials',
  'bom.empty': 'Configure the ramp to see the BOM.',
  'recap.3d_panel.aria': '3D view of the configured ramp',
};
